module.exports = "https://cdn.hellotech.com/client-assets/prod-specialist_905f672a3d6cfc9f4a889a6f145563ef.png";